import { trackApiCall } from './apiTrackerState';

// Service to track Google API calls across the application
export class ApiTrackingService {
  private static instance: ApiTrackingService;
  
  private constructor() {}
  
  static getInstance(): ApiTrackingService {
    if (!ApiTrackingService.instance) {
      ApiTrackingService.instance = new ApiTrackingService();
    }
    return ApiTrackingService.instance;
  }
  
  // Track Places API calls
  trackPlacesSearch(params: any, fromCache: boolean = false) {
    const details = `${params.categories || 'all'} near ${params.latitude?.toFixed(4)}, ${params.longitude?.toFixed(4)}`;
    trackApiCall('places_search', details, fromCache);
  }
  
  trackPlaceDetails(placeId: string, fromCache: boolean = false) {
    trackApiCall('place_details', `Place ID: ${placeId.substring(0, 20)}...`, fromCache);
  }
  
  trackPlacePhoto(photoRef: string, fromCache: boolean = false) {
    const details = `Photo: ${photoRef.substring(0, 20)}...`;
    trackApiCall('place_photo', details, fromCache);
  }
  
  // Track Distance Matrix API calls
  trackDistanceMatrix(origins: string[], destinations: string[], fromCache: boolean = false) {
    const details = `${origins.length} origins to ${destinations.length} destinations`;
    trackApiCall('distance_matrix', details, fromCache);
  }
  
  // Track Geocoding API calls
  trackGeocoding(address: string, fromCache: boolean = false) {
    trackApiCall('geocoding', `Address: ${address.substring(0, 30)}...`, fromCache);
  }
  
  trackReverseGeocoding(lat: number, lng: number, fromCache: boolean = false) {
    trackApiCall('reverse_geocoding', `${lat.toFixed(4)}, ${lng.toFixed(4)}`, fromCache);
  }
  
  // Track Maps JavaScript API usage
  trackMapLoad() {
    trackApiCall('maps_javascript', 'Map loaded');
  }
  
  trackMapInteraction(type: string) {
    trackApiCall('maps_javascript', `Interaction: ${type}`);
  }
  
  // Generic method for custom API tracking
  trackCustomApi(apiName: string, details?: string) {
    trackApiCall(apiName, details || '');
  }
  
  // Track backend API calls
  trackAPICall(endpoint: string, method: string = 'GET') {
    trackApiCall('backend_api', `${method} ${endpoint}`);
  }
}

export const apiTrackingService = ApiTrackingService.getInstance();